import match from 'autosuggest-highlight/match';

// inputValue is expected to be already normalised (deburred + lowercased) by the caller.
export function getMatchingClientIds(suggestion, inputValue) {
	if (!inputValue) {
		return [];
	}
	const clientIds = suggestion.clientIds || [];
	return clientIds.filter(clientId => String(clientId).includes(inputValue));
}

export default function organisationMatchesSearch(suggestion, inputValue) {
	if (!inputValue) {
		return false;
	}
	if (match(suggestion.name, inputValue).length > 0) {
		return true;
	}
	return getMatchingClientIds(suggestion, inputValue).length > 0;
}
